export default __webpack_public_path__ + "static/media/client.4a85a600.jpeg";